import React, { useContext, useEffect, useState } from "react";
import { AuthContext, Role } from "../../../context/AuthProvider";

import axios from "axios";
import { axiosWrapper } from "../../../hooks/axios";

const useInteractiveQuizAnswersFromActiveLicenses = (unique_quiz_id: string, question_id?: string) => {
    const user = useContext(AuthContext);
    const [activeStudyGroups, setActiveStudyGroups] = useState<any[]>([])
    const [quizAnswers, setQuizAnswers] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setIsLoading(true);
                const studyGroups = await axios.get('/api/v1/records/study_groups/active/', 
                   {
                    headers: {
                        'X-CSRFToken': JSON.parse(
                            document.getElementById('csrf_token')!.innerHTML,
                          ),
                    }
                   }
                )

                if (studyGroups) {
                    setActiveStudyGroups(studyGroups.data)
                }

                const result = await axios.post(
                    '/api/v1/syllabus/interactive_quiz_answers/filter/',
                    {
                        study_group_ids: studyGroups.data.map((sg: any) => sg.pk),
                        unique_quiz_id,
                        question_id
                    },
                    {
                        headers: {
                            'X-CSRFToken': JSON.parse(
                                document.getElementById('csrf_token')!.innerHTML,
                            ),
                            'Content-Type': 'application/json'
                        }
                    }
                );

                if (result.data) {
                    setQuizAnswers(result.data);
                    setIsLoading(false);
                }
            } catch (error) {
                console.error("Error fetching quiz answers:", error);
                setError("answers failed to load");
                setIsLoading(false);
            }
        };

        fetchData();
    }, []);

    return {
        quizAnswers,
        isLoading,
        error
    };
};

export default useInteractiveQuizAnswersFromActiveLicenses;


